import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTreasure: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconTreasure"><Path d="M5.5 4.5C3.84315 4.5 2.5 5.84315 2.5 7.5V19.5H21.5V7.5C21.5 5.84315 20.1569 4.5 18.5 4.5H5.5Z" stroke="currentColor"/><Path d="M2.5 10.5H21.5" stroke="currentColor"/><Path d="M7.5 4.5V19.5" stroke="currentColor"/><Path d="M16.5 4.5V19.5" stroke="currentColor"/><Path d="M12 9.5V11.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconTreasure;
